"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Twitter, Linkedin, Github, Mail } from "lucide-react";
function FooterMenuColumn() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Article Hub
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const resources = [{
    label: "Article Hub",
    href: "/ArticlesPage"
  }, {
    label: "Media Gallery",
    href: "/MediaPage"
  }, {
    label: "About Solomon",
    href: "/SolomonBrownPage"
  }, {
    label: "Contact",
    href: "/ContactPage"
  }];
  const socials = [{
    icon: Twitter,
    label: "Twitter",
    href: "#"
  }, {
    icon: Linkedin,
    label: "LinkedIn",
    href: "#"
  }, {
    icon: Github,
    label: "GitHub",
    href: "#"
  }, {
    icon: Mail,
    label: "Email",
    href: "mailto:solomon@autopulse.com"
  }];
  const currentYear = new Date().getFullYear();
  return <section data-section-id="214273" id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto w-full px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="flex flex-col items-start">
            <Link to="/" className="inline-block mb-6">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631141/img/finengage_logo_dark.png" alt="AutoPulse Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground font-default leading-relaxed max-w-xs">Bridging the gap, between journalism and automovie enthusiam. Sol is a devout enthusiast, looking to further capitalize on his passion and share it with those who have the same pulse!</p>
          </div>

          <div>
            <h3 className="font-default font-semibold text-base mb-6 tracking-tight text-foreground">
              Quick Laps
            </h3>
            <MenuProvider menu_id="47">
              <FooterMenuColumn />
            </MenuProvider>
          </div>

          

          <div>
            <h3 className="font-default font-semibold text-base mb-6 tracking-tight text-foreground">
              Connect
            </h3>
            <div className="flex flex-wrap gap-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <div key={social.label} data-index={i}>
                    <Button variant="ghost" size="icon" className="text-muted-foreground hover:text-primary hover:bg-primary/10 rounded-none border border-transparent hover:border-primary/20" asChild>
                      <Link to={social.href} newTab={social.href.startsWith("http") || social.href.startsWith("mailto:")}>
                        <Icon className="size-5" />
                        <span className="sr-only">{social.label}</span>
                      </Link>
                    </Button>
                  </div>;
            })}
            </div>
            <div className="mt-6">
              <p className="text-sm text-muted-foreground font-default">
                Inquiries? Reach out directly at<br />
                <Link to="mailto:solomon@autopulse.com" className="text-primary hover:underline mt-1 inline-block font-default">msmspeed727@gmail.com</Link>
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <Separator className="absolute left-0 right-0 w-full mb-8 opacity-20 bg-secondary" />
          <div className="w-full flex flex-col md:flex-row justify-between items-center gap-4 mt-4">
            <p className="text-xs text-muted-foreground font-default">
              &copy; {currentYear} AutoPulse. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs text-muted-foreground font-default">
              <Link to="#" className="hover:text-primary transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="hover:text-primary transition-colors">
                Terms of Service
              </Link>
              <Link to="#" className="hover:text-primary transition-colors">
                Security
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}